/**
 * Converts the first letter of a string to lowercase.
 * @param {string} inputString - The string to convert.
 * @returns {string} The converted string.
 */
export const lowerFirst = (inputString: string): string => {
    return inputString[0].toLowerCase() + inputString.slice(1);
};
